import {
  serviceLPlusExternal,
  serviceLPlusCP,
} from "../../../service/leadsterplus.service";

/**
 * @name requestLPlusCP
 * @returns Realiza a requisição de bootstrap para o Leadster Plus,
 * buscando o token inicial de troca (bootstrap_jwt) e a url base do L+ (lplus_base_url)
 */
export const requestLPlusCP = async (opportunityId, token) => {
  const data = {
    opportunityId,
  };

  // busca o token inicial de troca (bootstrap_jwt) e a url base do L+ (lplus_base_url)
  const lPlusCP = await serviceLPlusCP(token, data);

  if (lPlusCP && lPlusCP.status === 200)
    return lPlusCP?.data?.output || undefined;
  else return;
};

/**
 * @name requestLPlusExternal
 * @param {*} bootstrap_jwt
 * @param {*} lplus_base_url
 * @returns Realiza a requisição de troca de tokens para o Leadster Plus, utilizando o token inicial de troca (bootstrap_jwt)
 * e a url base do L+ (lplus_base_url) obtidos na requisição anterior.
 * Em caso de sucesso, armazena o refresh_token no cookie do browser e concede acesso ao widget.
 * Em caso de falha, nega acesso ao widget e exibe mensagem de erro.
 */
export const requestLPlusExternal = async (bootstrap_jwt, lplus_base_url) => {
  const lPlusExternal = await serviceLPlusExternal(
    bootstrap_jwt,
    lplus_base_url,
  );

  if (lPlusExternal && lPlusExternal.status === 200) return lPlusExternal.data;
  else return;
};
